import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
// import logocolor from '../shantal-logo.png';
class ComponentToPrint extends React.PureComponent{
	render() {
		let sesion = JSON.parse( localStorage.getItem('sesion'));
		let data = this.props.data;
		let list = [];
		const th = {
			fontSize : '11px'
		}
		const thp = {
			width: '130px',
			fontSize : '11px'
		}
		let descuento = 0;
		let totalPrint = 0;
		let devolucion = '';
		if( data.car.length > 0 ){
			data.car.forEach((e,i)=>{
					let tmp;
						if(JSON.parse(localStorage.sesion).rol == 2){
							tmp = e.nombre;
							tmp = tmp.split('-');
							tmp = tmp[0];
						}else{
							tmp = e.nombre;
						}
				list.push(
					<tr key={i}>
						<td style={thp}>{tmp}</td>
						<td style={th}>{e.precio}</td>
						<td style={th}>{e.cantidad}</td>
					</tr>
				);
				if( e.devolucion === 'Si' ){
					devolucion = 'si';
				}
				totalPrint = Number(totalPrint) + Number(e.precio * e.cantidad);
			});
		}
		if( devolucion === 'si' ){
			descuento = totalPrint * (data.venta.descuento/100);
		}else{
			descuento = 0;
		}
		return (
			<div className="ticket" style={{paddingLeft:'30px',paddingBottom:'50px',marginTop:'20px'}}>
				<p>Folio: {data.venta.codigo}</p>
				<p>Sucursal: {sesion.sucursal_name}</p>
				<p>Vendedor: {sesion.display_name}</p>
				<p>Fecha: {data.venta.fecha}</p>
				<p>Transacción: { data.venta.transaccion === 2 ? 'Cambio' : 'Venta' }</p>
				<table style={{marginBottom:'50px'}}>
					<thead>
						<tr key={1}>
							<th style={thp}>Producto</th>
							<th style={th}>Precio</th>
							<th style={th}>Cantidad</th>
						</tr>
					</thead>
					<tbody>
						{ list ? list : '' }
					</tbody>
					<tfoot>
						<tr>
							<td></td><td style={th}>SubTotal:</td><td style={th}>{window.$fmoney(data.venta.subtotal, 2)}</td>
						</tr>
						<tr>
							<td></td><td style={th}>Descuento:</td><td style={th}>
								{ window.$fmoney(descuento,2) } - {data.venta.descuento}%
							</td>
						</tr>
						<tr>
							<td></td><td style={th}>Total:</td><td style={th}>{window.$fmoney(data.venta.total, 2)}</td>
						</tr>
						<tr>
							<td></td><td style={th}>Pago con:</td><td style={th}>{window.$fmoney(data.venta.paga_con, 2)}</td>
						</tr>
						<tr>
							<td></td>
							<td style={th}>Forma de pago:</td>
							<td style={th}>{ data.venta.formaDePago === "2" || data.venta.formaDePago === 2 ? 'Tarjeta' : 'Efectivo' }</td>
						</tr>
						<tr>
							<td></td><td style={th}>Cambio:</td><td style={th}>{window.$fmoney(data.venta.cambio, 2)}</td>
						</tr>
					</tfoot>
				</table>
			</div>
	  )
	}
}
function PrintTicket(props){
	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content : () => componentRef.current
	});
	return(
		<div className={props.print ? 'overlay show':'overlay'}>
			<div className="content">
				<div className="modal_header">
					<h5>Ticket</h5>
					<span className="close-pop-up" onClick={props.closeModalPrint}>x</span>
				</div>
				<div className="modal_body text-center" style={{'overflow':'auto','height':'400px'}}>
					<button onClick={handlePrint} 
						className="btn-small btn-green"
						style={{'width':'200px'}}
					>Imprimir</button>
					<br/><br/>
					<ComponentToPrint  ref={componentRef} data={props.elTicket}/>
				</div>
			</div>
		</div>
	)
}
export default PrintTicket;